import {useEffect, useRef} from 'react';

import {useUDData} from '@udemy/ud-data';

import {initGoogleTokenClient, requestGoogleAccessToken} from '../api/google-calendar-auth-api';

import type {GoogleTokenResponse, TokenClient} from '../api/google-calendar-auth-api';

export interface UseGoogleCalendarAuthResult {
    isAvailable: boolean;
    requestAccessToken: () => Promise<GoogleTokenResponse>;
}

export function useGoogleCalendarAuth(): UseGoogleCalendarAuthResult {
    const {Config} = useUDData();
    const googleClientId: string | undefined = Config?.third_party?.google_client_id;
    const tokenClientRef = useRef<TokenClient | null>(null);

    useEffect(() => {
        if (!googleClientId) return;
        let cancelled = false;

        initGoogleTokenClient(googleClientId).then((tokenClient) => {
            if (!cancelled) tokenClientRef.current = tokenClient;
        });

        return () => {
            cancelled = true;
        };
    }, [googleClientId]);

    const requestAccessToken = () => requestGoogleAccessToken(tokenClientRef.current);

    return {
        isAvailable: !!googleClientId,
        requestAccessToken,
    };
}
